import { ISchedule } from "Pages/Setup/Scheduler/Scheduler";
import { splitScheduleIntegration } from "Pages/Setup/Scheduler/scheduleArgs";
import { Input, Label } from "reactstrap";

import styles from "Pages/Setup/Scheduler/Components/AddSchedule/CronSelector/IntegrationArguments/IntegrationArguments.module.css";

interface IProps {
    integrationIndex: number;
    integrations: IIntegration[];
    schedule: ISchedule;
    scheduleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/** Renders the inputs for each integration argument. Called in JSX below.
 * @param index The index of the integration in the schedule state.
 * @returns inputs for each integration argument.
 */
export default function IntegrationArguments({
    integrationIndex,
    integrations,
    schedule,
    scheduleChange,
}: IProps) {
    /** The raw integration data matching the schedule. The split is necessary to get just the
     * name before any slashes and integration arguments.
     */
    const integration = integrations.find(
        (i) =>
            i.process ===
            splitScheduleIntegration(schedule.integrations[integrationIndex])
                .process
    );

    // Render nothing if no integration or arguments
    if (!integration || !integration.arguments.length) return <></>;

    /** Disables the argument input if any before the current input is/are blank */
    const isDisabled = (integrationIndex: number, argIndex: number) => {
        const integration = schedule.integrations[integrationIndex];
        // dimension-fhmsz: decode before counting -- split("/") counted a '/'-bearing argument
        // as two, which shifted the disabled state of every later input.
        const args = splitScheduleIntegration(integration).args;

        if (argIndex === 0) return false;
        if (args.length === 0) return true;

        const disabled = argIndex - args.length >= 1;

        return disabled;
    };

    return (
        <div className={styles.argumentsBox}>
            {integration.arguments.map((a, argIndex) => (
                <Label htmlFor={a.name + argIndex} key={argIndex}>
                    <Input
                        key={argIndex}
                        type="text"
                        id={a.name + argIndex}
                        name={`argument-${integrationIndex}-${argIndex}`}
                        className={styles.argument}
                        value={
                            splitScheduleIntegration(
                                schedule.integrations[integrationIndex]
                            ).args[argIndex] || ""
                        }
                        onChange={scheduleChange}
                        disabled={isDisabled(integrationIndex, argIndex)}
                        placeholder={a.name}
                    />
                </Label>
            ))}
        </div>
    );
}
